export default [
    'UserAuthentication',
    'ForgotPassword',
	'ForgotPassword',
	'LoginByPassword',
    'GetToken', //获取token
    'GetTsCodeList',// 获取股票代码列表
];


// WEBPACK FOOTER //
// ./src/constants/apiPermission.js